export default __webpack_public_path__ + "static/media/file_download_24dp.f2cd2685.svg";